import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const authHeader = (): Record<string, string> => {
  const token = localStorage.getItem('authToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Rascunhos de formulário (oficina/at-136): o que a pessoa estava preenchendo no cadastro de
 * veículo ou no checklist sobrevive ao recarregamento que a versão nova do sistema faz sozinha.
 * Cada usuário só alcança os próprios. Sem catch aqui (regra da at-60) — quem trata é quem chama.
 */
export const CHAVE_CADASTRO_VEICULO = 'cadastro-veiculo';
export const chaveDoChecklist = (carId: string, tipo: string) => `checklist:${carId}:${tipo}`;

export interface ResumoDoRascunho {
  chave: string;
  atualizadoEm: string;
}

export interface Rascunho<T = Record<string, unknown>> extends ResumoDoRascunho {
  conteudo: T;
}

export async function listarRascunhos(): Promise<ResumoDoRascunho[]> {
  const { data } = await axios.get<ResumoDoRascunho[]>(`${BACKEND_URL}/rascunhos`, { headers: authHeader() });
  return data;
}

/** `null` quando não há rascunho (o 404 é estado legítimo, não falha). */
export async function obterRascunho<T>(chave: string): Promise<Rascunho<T> | null> {
  try {
    const { data } = await axios.get<Rascunho<T>>(`${BACKEND_URL}/rascunhos/${encodeURIComponent(chave)}`, {
      headers: authHeader(),
    });
    return data;
  } catch (error: any) {
    if (error?.response?.status === 404) return null;
    throw error;
  }
}

export async function salvarRascunho(chave: string, conteudo: Record<string, unknown>): Promise<void> {
  await axios.put(`${BACKEND_URL}/rascunhos/${encodeURIComponent(chave)}`, { conteudo }, { headers: authHeader() });
}

export async function descartarRascunho(chave: string): Promise<void> {
  await axios.delete(`${BACKEND_URL}/rascunhos/${encodeURIComponent(chave)}`, { headers: authHeader() });
}
